import { Group, Object3D, Mesh } from 'three';
import { UserDataProp } from '../types';

export abstract class RenderUtils {
	static clearGroup(group: Group) {
		group.traverse((object) => {
			if (!RenderUtils.isMesh(object)) return;

			if (object.geometry) object.geometry.dispose();
		});

		group.clear();
	}

	static isMesh(object: Object3D): object is Mesh {
		return object instanceof Mesh;
	}

	static searchSofaModuleGroup(object: Object3D): Object3D | null {
		if (object.userData[UserDataProp.IS_SOFA_MODULE]) return object;
		if (!object.parent || object.parent.userData[UserDataProp.IS_COLLECTION])
			return null;
		return RenderUtils.searchSofaModuleGroup(object.parent);
	}
}
